import React, { useState } from "react";
import Button from "../../ui/Button";

const ModalComponent = ({
    icon,
    title,
    message,
    secondMessage,
    checkboxLabel,
    firstButtonLabel,
    firstButtonDisabled = false,
    firstButtonVariant = "default",
    onFirstButtonClick,
    secondButtonLabel,
    secondButtonVariant = "default",
    onSecondButtonClick,
    childrenPosition = "above",
    children
}) => {
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsCheckboxChecked(!isCheckboxChecked);
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-opacity-100 bg-grey-25">
            <div className="justify-center w-full max-w-md p-6 bg-white shadow-lg rounded-2xl">
                {icon && (
                    <div className="flex justify-center space-x-4">
                        {icon}
                    </div>
                )}
                {title && (
                    <h2 className="justify-center my-4 text-lg font-semibold text-center text-grey-900">
                        {title}
                    </h2>
                )}
                {message && (
                    <p className="mb-6 text-sm text-center text-grey-600">{message}</p>
                )}
                {secondMessage && (
                    <p className="mb-6 text-sm text-center text-grey-600 px-12">{secondMessage}</p>
                )}
                {checkboxLabel && (
                    <div className="flex items-center pl-4 mb-8 space-x-2">
                        <input
                            type="checkbox"
                            id="selectAll"
                            checked={isCheckboxChecked}
                            onChange={handleCheckboxChange}
                            className="w-4 h-4 rounded border-grey-300 accent-error-500"
                        />
                        <label htmlFor="selectAll" className="text-xs text-grey-900">
                            <span className="text-sm text-grey-900">{checkboxLabel}</span>
                        </label>
                    </div>
                )}
                <div
                    className={`flex ${childrenPosition === "below" ? "flex-col-reverse" : "flex-col"
                        } items-center space-y-6`}
                >
                    {children}
                    <div className="flex justify-center space-x-4">
                        {secondButtonLabel && (
                            <Button
                                variant={secondButtonVariant}
                                onClick={onSecondButtonClick}
                            >
                                {secondButtonLabel}
                            </Button>
                        )}
                        <Button
                            variant={firstButtonVariant}
                            onClick={() => {
                                if (!checkboxLabel || isCheckboxChecked) {
                                    onFirstButtonClick();
                                }
                            }}
                            disabled={(checkboxLabel && !isCheckboxChecked) || firstButtonDisabled}
                        >
                            {firstButtonLabel}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalComponent;